export default __webpack_public_path__ + "static/media/github-icon-1.b17ecb92.svg";